import React, { useEffect, useState } from "react";
import { adminGetAllWalletTransactions } from "../api/admin";
import WalletTable from "../components/WalletTable";

const WalletPage = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [walletData, setWalletData] = useState(null);
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  useEffect(() => {
    adminGetAllWalletTransactions()
      .then((res) => {
        let resBody = res.data;
        if (Array.isArray(resBody) && resBody.length > 0) resBody = resBody[0];
        
        const rawData = resBody?.data || resBody;
        setWalletData(rawData);
        setTransactions(rawData?.transactions || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Wallet API error:", err);
        setError("Failed to fetch transactions.");
        setLoading(false);
      });
  }, []);

  return (
    <div className="admin-page">
      <div className="page-header">
        <h2 className="adminproducts">Wallet Management</h2>
      </div>

      {walletData?.summary && (
        <div className="wallet-summary-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '25px' }}>
          <div className="summary-card" style={{ padding: '20px', background: '#fff', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', borderLeft: '5px solid #50cd89' }}>
            <span style={{ color: '#7e8299', fontSize: '0.9rem' }}>Total Credit</span>
            <h3 style={{ margin: '5px 0 0', color: '#181c32' }}>₹{walletData.summary.totalCredit}</h3>
          </div>
          <div className="summary-card" style={{ padding: '20px', background: '#fff', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', borderLeft: '5px solid #f1416c' }}>
            <span style={{ color: '#7e8299', fontSize: '0.9rem' }}>Total Debit</span>
            <h3 style={{ margin: '5px 0 0', color: '#181c32' }}>₹{walletData.summary.totalDebit}</h3>
          </div>
          <div className="summary-card" style={{ padding: '20px', background: '#fff', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', borderLeft: '5px solid #009ef7' }}>
            <span style={{ color: '#7e8299', fontSize: '0.9rem' }}>Net Balance</span>
            <h3 style={{ margin: '5px 0 0', color: '#181c32' }}>₹{walletData.summary.netAmount}</h3>
          </div>
        </div>
      )}

      {loading ? (
        <div className="loading-state"><p>Loading...</p></div>
      ) : error ? (
        <div className="error-state" style={{ padding: '20px', color: '#f1416c', backgroundColor: '#fff5f8', borderRadius: '8px' }}>
          <p>{error}</p>
        </div>
      ) : (
        <WalletTable transactions={transactions} onView={(tx) => setSelectedTransaction(tx)} />
      )}

      {/* Transaction Detail Modal */}
      {selectedTransaction && (
        <div className="modal-overlay" onClick={() => setSelectedTransaction(null)}>
          <div className="modal-content" style={{ maxWidth: '500px' }} onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Transaction Details</h3>
              <button className="close-btn" onClick={() => setSelectedTransaction(null)}>&times;</button>
            </div>
            <div className="form-body" style={{ padding: '30px' }}>
              <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                 <div style={{ 
                   fontSize: '2rem', 
                   fontWeight: '800', 
                   color: selectedTransaction.type === 'credit' ? '#50cd89' : '#f1416c' 
                 }}>
                   {selectedTransaction.type === 'credit' ? '+' : '-'}₹{selectedTransaction.amount}
                 </div>
                 <div style={{ textTransform: 'capitalize', fontWeight: '600', color: '#7e8299' }}>
                   {selectedTransaction.type?.replace('_', ' ')}
                 </div>
              </div>

              <div style={{ display: 'grid', gap: '15px' }}>
                 <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #f1f1f1', paddingBottom: '10px' }}>
                    <span style={{ color: '#7e8299' }}>Status</span>
                    <span style={{ fontWeight: '700', textTransform: 'capitalize', color: selectedTransaction.status === 'completed' ? '#50cd89' : '#ffc700' }}>
                      {selectedTransaction.status}
                    </span>
                 </div>
                 <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #f1f1f1', paddingBottom: '10px' }}>
                    <span style={{ color: '#7e8299' }}>User</span>
                    <span style={{ fontWeight: '700' }}>{selectedTransaction.user?.name || '-'}</span>
                 </div>
                 <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #f1f1f1', paddingBottom: '10px' }}>
                    <span style={{ color: '#7e8299' }}>Email</span>
                    <span style={{ fontWeight: '600' }}>{selectedTransaction.user?.email || '-'}</span>
                 </div>
                 <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #f1f1f1', paddingBottom: '10px' }}>
                    <span style={{ color: '#7e8299' }}>Date</span>
                    <span>{new Date(selectedTransaction.createdAt).toLocaleString()}</span>
                 </div>
                 <div style={{ marginTop: '10px' }}>
                    <div style={{ color: '#7e8299', marginBottom: '5px' }}>Description</div>
                    <div style={{ padding: '12px', background: '#f8f9fa', borderRadius: '8px', fontSize: '0.9rem' }}>
                      {selectedTransaction.description || 'No description provided.'}
                    </div>
                 </div>
              </div>
            </div>
            <div className="form-footer">
              <button className="btn-cancel" onClick={() => setSelectedTransaction(null)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WalletPage;
